import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { Link as RouterLink } from 'react-router-dom';

// Markdown components configuration
const markdownComponents = {
  p: ({ node, ...props }) => (
    <Typography component="span" variant="body1" sx={{ display: 'block', mb: 1 }}>
      {props.children}
    </Typography>
  ),
  a: ({ node, href, ...props }) => {
    const isInternal = href?.startsWith('/');
    if (isInternal) {
      return (
        <RouterLink
          to={href}
          style={{ color: '#1abc9c', textDecoration: 'underline' }}
        >
          {props.children}
        </RouterLink>
      );
    }
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: '#1abc9c', textDecoration: 'underline' }}
        {...props}
      />
    );
  },
  li: ({ node, ...props }) => (
    <Typography component="li" variant="body1" sx={{ ml: 2 }}>
      {props.children}
    </Typography>
  ),
  ul: ({ node, ...props }) => (
    <Box component="ul" sx={{ m: 0, pl: 2 }}>
      {props.children}
    </Box>
  ),
  ol: ({ node, ...props }) => (
    <Box component="ol" sx={{ m: 0, pl: 2 }}>
      {props.children}
    </Box>
  ),
  strong: ({ node, ...props }) => (
    <Box component="strong" sx={{ fontWeight: 'bold' }}>
      {props.children}
    </Box>
  ),
};

const ThreeColumns = ({ content, url }) => (
  <Box id={url || ''} sx={{ mb: 10, maxWidth: '1200px', mx: 'auto', px: 2 }}>
    <Grid container spacing={4}>
      {content.map((item, index) => (
        <Grid item xs={12} md={4} key={index}>
          <Box sx={{ textAlign: 'center' }}>
            <img
              src={item.image}
              alt={item.title}
              style={{ width: '100%', borderRadius: '4px', marginBottom: '16px' }}
            />
            <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>{item.title}</Typography>
            <Box sx={{ '& > *:last-child': { mb: 0 } }}>
              <ReactMarkdown components={markdownComponents}>
                {item.text}
              </ReactMarkdown>
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default ThreeColumns;